/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DashboardOptionsRequest,
  DashboardOptionsResponse,
  DashboardRenderRequest,
  DashboardSummary,
  HTTPValidationError,
  RenderedDashboard,
} from '../models/index';
import {
    DashboardOptionsRequestFromJSON,
    DashboardOptionsRequestToJSON,
    DashboardOptionsResponseFromJSON,
    DashboardOptionsResponseToJSON,
    DashboardRenderRequestFromJSON,
    DashboardRenderRequestToJSON,
    DashboardSummaryFromJSON,
    DashboardSummaryToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    RenderedDashboardFromJSON,
    RenderedDashboardToJSON,
} from '../models/index';

export interface ListTemplatesApiV1DashboardsTemplatesGetRequest {
    view?: ListTemplatesApiV1DashboardsTemplatesGetViewEnum;
}

export interface RenderTemplateApiV1DashboardsTemplatesTemplateIdRenderPostRequest {
    templateId: string;
    dashboardRenderRequest: DashboardRenderRequest;
}

export interface ResolveControlOptionsApiV1DashboardsTemplatesTemplateIdOptionsPostRequest {
    templateId: string;
    dashboardOptionsRequest: DashboardOptionsRequest;
}

/**
 * 
 */
export class DashboardsApi extends runtime.BaseAPI {

    /**
     * List dashboard templates available to the user as lightweight `{id, name}` items.
     * List Templates
     */
    async listTemplatesApiV1DashboardsTemplatesGetRaw(requestParameters: ListTemplatesApiV1DashboardsTemplatesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DashboardSummary>>> {
        const queryParameters: any = {};

        if (requestParameters['view'] != null) {
            queryParameters['view'] = requestParameters['view'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dashboards/templates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DashboardSummaryFromJSON));
    }

    /**
     * List dashboard templates available to the user as lightweight `{id, name}` items.
     * List Templates
     */
    async listTemplatesApiV1DashboardsTemplatesGet(requestParameters: ListTemplatesApiV1DashboardsTemplatesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DashboardSummary>> {
        const response = await this.listTemplatesApiV1DashboardsTemplatesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Render a template against the applied control selections (structure + filled data).  The instance scope travels inside ``selections`` (the ``install_base_id``-dimension control); the service maps it onto the RBAC-checked instance list.
     * Render Template
     */
    async renderTemplateApiV1DashboardsTemplatesTemplateIdRenderPostRaw(requestParameters: RenderTemplateApiV1DashboardsTemplatesTemplateIdRenderPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RenderedDashboard>> {
        if (requestParameters['templateId'] == null) {
            throw new runtime.RequiredError(
                'templateId',
                'Required parameter "templateId" was null or undefined when calling renderTemplateApiV1DashboardsTemplatesTemplateIdRenderPost().'
            );
        }

        if (requestParameters['dashboardRenderRequest'] == null) {
            throw new runtime.RequiredError(
                'dashboardRenderRequest',
                'Required parameter "dashboardRenderRequest" was null or undefined when calling renderTemplateApiV1DashboardsTemplatesTemplateIdRenderPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/dashboards/templates/{template_id}/render`.replace(`{${"template_id"}}`, encodeURIComponent(String(requestParameters['templateId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DashboardRenderRequestToJSON(requestParameters['dashboardRenderRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RenderedDashboardFromJSON(jsonValue));
    }

    /**
     * Render a template against the applied control selections (structure + filled data).  The instance scope travels inside ``selections`` (the ``install_base_id``-dimension control); the service maps it onto the RBAC-checked instance list.
     * Render Template
     */
    async renderTemplateApiV1DashboardsTemplatesTemplateIdRenderPost(requestParameters: RenderTemplateApiV1DashboardsTemplatesTemplateIdRenderPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RenderedDashboard> {
        const response = await this.renderTemplateApiV1DashboardsTemplatesTemplateIdRenderPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolve the selectable values for each control, given the caller\'s staged selections.
     * Resolve Control Options
     */
    async resolveControlOptionsApiV1DashboardsTemplatesTemplateIdOptionsPostRaw(requestParameters: ResolveControlOptionsApiV1DashboardsTemplatesTemplateIdOptionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardOptionsResponse>> {
        if (requestParameters['templateId'] == null) {
            throw new runtime.RequiredError(
                'templateId',
                'Required parameter "templateId" was null or undefined when calling resolveControlOptionsApiV1DashboardsTemplatesTemplateIdOptionsPost().'
            );
        }

        if (requestParameters['dashboardOptionsRequest'] == null) {
            throw new runtime.RequiredError(
                'dashboardOptionsRequest',
                'Required parameter "dashboardOptionsRequest" was null or undefined when calling resolveControlOptionsApiV1DashboardsTemplatesTemplateIdOptionsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/dashboards/templates/{template_id}/options`.replace(`{${"template_id"}}`, encodeURIComponent(String(requestParameters['templateId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DashboardOptionsRequestToJSON(requestParameters['dashboardOptionsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DashboardOptionsResponseFromJSON(jsonValue));
    }

    /**
     * Resolve the selectable values for each control, given the caller\'s staged selections.
     * Resolve Control Options
     */
    async resolveControlOptionsApiV1DashboardsTemplatesTemplateIdOptionsPost(requestParameters: ResolveControlOptionsApiV1DashboardsTemplatesTemplateIdOptionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardOptionsResponse> {
        const response = await this.resolveControlOptionsApiV1DashboardsTemplatesTemplateIdOptionsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ListTemplatesApiV1DashboardsTemplatesGetViewEnum = {
    Summary: 'summary'
} as const;
export type ListTemplatesApiV1DashboardsTemplatesGetViewEnum = typeof ListTemplatesApiV1DashboardsTemplatesGetViewEnum[keyof typeof ListTemplatesApiV1DashboardsTemplatesGetViewEnum];
